import { useMutation } from '@tanstack/react-query';
import { apiClient } from '../apiClient';
import { getQueryKeyBase, MUTATION_KEYS, queryClient } from '../queryClient';
import { updateCacheArray, CACHE_ACTIONS } from '../cacheClient';
import { getQueryKey as getQueryKeySecuritySchemes } from './useSecuritySchemes';
import { getQueryKey as getQueryKeySecuritySchemeById } from './useSecuritySchemeById';

// Config
import { uiConfig } from '../../../conf/securitySchemes';

export const getMutationKey = getQueryKeyBase.bind(null, MUTATION_KEYS.SECURITY_SCHEME);

export const useUpdateScheme = ({ crudConfig, sessionToken, onSuccessCb, onErrorCb, onSettledCb }) => {
    const Client = apiClient(crudConfig);

    return useMutation({
        mutationKey: getMutationKey(),
        mutationFn: ({ update }) => Client.update(sessionToken, update.schemeId, update),
        onSuccess: (data, variables, context) => {
            updateCacheArray({
                queryKey: getQueryKeySecuritySchemes(),
                action: CACHE_ACTIONS.UPDATE,
                primaryKey: uiConfig.primaryKey,
                data
            });
            queryClient.invalidateQueries({
                queryKey: getQueryKeySecuritySchemeById(data.schemeId)
            });
            onSuccessCb?.({ context: variables?.context });
        },
        onError: (error) => {
            console.log('Error', error);
            onErrorCb?.(error);
        },
        onSettled: () => {
            onSettledCb?.();
        },
        refetchOnWindowFocus: false
    });
};
